var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"page-pc",staticClass:"page-pc",style:(_vm.rootStyle)},[_c('flow-container',{staticClass:"page-pc-child",attrs:{"children":_vm.tpl.children}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./src/render/index.vue?vue&type=template&id=6ec993ba&scoped=true&
// module id = 21
// module chunks = 1